"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const vasat_1 = require("vasat");
const app_service_1 = require("../../commons/app.service");
const acl_service_1 = require("../../commons/acl/acl.service");
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const core_2 = require("@ngx-translate/core");
const users_component_1 = require("./users.component");
class UsersDetails extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, permissions, router, snackBar, dialog, activeRoute, applicationEvents, t, userEditor) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.permissions = permissions;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.activeRoute = activeRoute;
        this.t = t;
        this.userEditor = userEditor;
        this.loading = false;
        this.projects = new rxjs_1.BehaviorSubject([]);
        this.tmp = [];
        this.canSave = false;
        this.showAddProjects = false;
        this.zz = 0;
    }
    init() {
        this.projects.subscribe(s => {
            this.canSave = s.find(ss => ss.scratched) && !s.find(ss => !ss.role);
            console.log(s);
        });
        this.fourD.V.searchByObject(vasat_1.Role).equals("desc", "4D Mapper|4D User").queryObservable().subscribe(s => {
            this.roles = s.items;
            this.refresh();
        });
    }
    refresh() {
        if (this.userStub) {
            this.loading = true;
            this.fourD.searchFor(_4d_mapper_1.Project).equals('shareUsers', this.userStub.user.id).equals('forUser', this.userStub.user.id).queryObservable().subscribe(r => {
                this.projects.next(r.items.map(r => {
                    var fc = new forms_1.FormControl();
                    fc.setValue(r['roles']);
                    return { project: r, role: fc, scratched: false, valid: true };
                }));
                this.loading = false;
            });
        }
    }
    ngOnChanges() {
        this.refresh();
    }
    removeUser() {
        this.openConfirmDelete(() => {
            (this.userStub.isInvite ?
                this.fourD.activeTeam.invitedUsers.removeObservable(this.userStub.user)
                :
                    this.userStub.group.users.removeObservable(this.userStub.user)).subscribe(_ => {
                this.openSnackBarInfo('USER_ADMIN.USER_DELETED');
                this.userEditor.curUser = null;
                this.userEditor.userList.next(this.userEditor.userList.value.filter(u => u != this.userStub));
            });
        }, this.userStub.user.name);
    }
    onRolesChange(cur) {
        cur.scratched = true;
        cur.valid = cur.role.value.length;
    }
    addProject(p = null) {
        p.shareUsers.addObserveable(this.userStub.user).subscribe(_ => {
            this.refresh();
            this.openSnackBarInfo('USER_ADMIN.PROJECT_SHARED');
        }, e => this.openSnackBarError(e.messsage));
    }
    addProjects() {
        this.showAddProjects = true;
    }
    closeAddProjects() {
        this.showAddProjects = false;
    }
    hasProject(currentProjects, p = null) {
        if (!p) {
            return false;
        }
        // if ( this.zz++ > 50 ) {
        // this.zz = 0;
        let test = currentProjects.find(pp => pp.project.id == p.id);
        // console.log('### hasProject', currentProjects, p, test );
        if (test) {
            return true;
        }
        // }
        return false;
    }
    addUserRole(stub) {
        var ss = '';
        stub.role.value.forEach(s1 => ss += s1 + ',');
        ss = ss.substring(0, ss.length - 1);
        this.fourD.V.put('/api/Project/' + stub.project.id + '.acl/' + ss + '/' + this.userStub.user.id, {}).subscribe(_ => this.openSnackBarInfo('USER_ADMIN.PROJECT_ROLES'), e => this.openSnackBarError(e.messsage));
    }
    removeUserFromProj(stub) {
        this.openConfirmDelete(() => {
            this.fourD.V.delete('/api/Project/' + stub.project.id + '.acl/' + this.userStub.user.id, {}).subscribe(_ => {
                this.openSnackBarInfo('USER_ADMIN.REMOVED');
                this.refresh();
            }, e => this.openSnackBarError(e.messsage));
        }, stub.project.name);
    }
    setAdmin() {
        this.fourD.activeTeam.accountGroups.queryObservable().pipe(operators_1.concatMap(ag => {
            var admins = ag.items.find(a => a.uid.endsWith("_admins"));
            var normal = ag.items.find(a => !a.uid.endsWith("_admins"));
            if (this.userStub.isAdmin) {
                return rxjs_1.forkJoin([
                    admins.users.addObserveable(this.userStub.user),
                    normal.users.removeObservable(this.userStub.user)
                ]);
            }
            else {
                return rxjs_1.forkJoin([
                    admins.users.removeObservable(this.userStub.user),
                    normal.users.addObserveable(this.userStub.user)
                ]);
            }
        })).subscribe(s => this.openSnackBarSuccess("GENERIC.UPDATED"), e => this.openSnackBarError(e.message));
    }
}
exports.UsersDetails = UsersDetails;
